import {put, takeEvery, call, select} from 'redux-saga/effects';
import {
    FEEDBACK_QUALITY_AUTOSAVE,
    FEEDBACK_QUALITY_AUTOSAVE_REQUEST,
    FEEDBACK_QUALITY_AUTOSAVE_SUCCESS,
    FEEDBACK_QUALITY_AUTOSAVE_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* qualityFeedbackAutosave(action: any) {

    const {
        feedbackId,
        feedbackStatus,
        comment,
        originalComment,
        rating,
        originalRate,
        recipientId,
        feedbacksType
    } = action.payload;

    const rate = (rating || rating === 0) ? Number(rating) : null;

    try {
        yield put({type: FEEDBACK_QUALITY_AUTOSAVE_REQUEST});

        const data = yield call(Api.fetch, {
            endpoint: feedbackId ? `feedback/${action.payload.feedbackId}` : 'feedback/',
            method: feedbackId ? ApiMethods.PUT : ApiMethods.POST,
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                ...(feedbackId ? {feedbackId} : null),
                feedbackType: feedbacksType,
                periodId: action.periodId,
                recipientId,
                feedbackData: {
                    ...(feedbackStatus !== 'NEW' ? {STATUS: 'NEW'} : null),
                    ...(comment !== originalComment ? {COMMENT: comment} : null),
                    ...(rating !== originalRate ? {RATING: rate} : null)
                }
            }
        });
        const {authenticated} = yield select();

        yield put({type: FEEDBACK_QUALITY_AUTOSAVE_SUCCESS, saveFeedback: data.responseData, authenticated});

        if (action.autosaveCallback) {
            yield action.autosaveCallback(data.responseData);
        }

    } catch (e) {
        yield put({type: FEEDBACK_QUALITY_AUTOSAVE_FAILURE, error: e});
    }
}

function* qualityFeedbackSagaAutosave() {
    yield takeEvery(FEEDBACK_QUALITY_AUTOSAVE, qualityFeedbackAutosave);
}

export default qualityFeedbackSagaAutosave;
